var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0V1.33333H3.33333V4C3.33333 4.83333 3.53472 5.60417 3.9375 6.3125C4.35417 7.02083 4.90972 7.58333 5.60417 8C4.90972 8.41667 4.35417 8.97917 3.9375 9.6875C3.53472 10.3958 3.33333 11.1667 3.33333 12V14.6667H2V16H14V14.6667H12.6667V12C12.6667 11.1667 12.4583 10.3958 12.0417 9.6875C11.6389 8.97917 11.0903 8.41667 10.3958 8C11.0903 7.58333 11.6389 7.02083 12.0417 6.3125C12.4583 5.60417 12.6667 4.83333 12.6667 4V1.33333H14V0H2ZM4.66667 1.33333H11.3333V4C11.3333 4.61111 11.1806 5.17361 10.875 5.6875C10.5833 6.1875 10.1806 6.59028 9.66667 6.89583C9.16667 7.1875 8.61111 7.33333 8 7.33333C7.38889 7.33333 6.82639 7.1875 6.3125 6.89583C5.8125 6.59028 5.40972 6.1875 5.10417 5.6875C4.8125 5.17361 4.66667 4.61111 4.66667 4V1.33333ZM8 8.66667C8.61111 8.66667 9.16667 8.81944 9.66667 9.125C10.1806 9.41667 10.5833 9.81944 10.875 10.3333C11.1806 10.8333 11.3333 11.3889 11.3333 12V14.6667H4.66667V12C4.66667 11.3889 4.8125 10.8333 5.10417 10.3333C5.40972 9.81944 5.8125 9.41667 6.3125 9.125C6.82639 8.81944 7.38889 8.66667 8 8.66667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHourglass);
export default __webpack_public_path__ + "static/media/ico-hourglass.b9fc65a1f170b4cad70234ece5190942.svg";
export { ForwardRef as ReactComponent };